module.exports = __webpack_public_path__ + "static/media/btn-del.3327e586.svg";